import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfCategory } from '../../database/index';

import { useAuth } from "src/contexts/auth";
import api from '../../services/api';

export const useFormCreateCategory = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [categoryResponse, setCategoryResponse] = useState<AxiosResponse | null>(null);
  const [categoryEditedResponse, setCategoryEditedResponse] = useState<AxiosResponse | null>(null);
  const history = useHistory();

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO: Yup.string().required('* Campo Obrigatório')
  });

  const saveCategory = async (category: ModelOfCategory) => {
    setLoading(true);

    const newCategory: ModelOfCategory = {
      ...category,
      ORGAO: userAgencyId
    }

    if (!!categoryResponse) {
      api.put(`categorys/${categoryResponse.data.ID}`, newCategory)
        .then((response) => {
          formik.resetForm();
          setCategoryEditedResponse(response);
          setCategoryResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A categoria foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      api.post('categorys', newCategory)
        .then((response) => {
          if (window.location.href === '/categoryForm') history.push('/listCategories');
          setLoading(false);
          setCategoryResponse(response);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  }

  const formik = useFormik<ModelOfCategory>({
    initialValues: {
      ORGAO: '',
      DESCRICAO: '',
    },
    onSubmit: async values => await saveCategory(values),
    validationSchema
  });

  return {
    getCategoryFormController: {
      formik,
      loading,
      toast,
      categoryResponse,
      categoryEditedResponse
    },
    handleCategoryFormController: {
      setCategoryResponse,
      setCategoryEditedResponse
    }
  };
};
